<script setup>
import {defineEmits, ref} from "vue";
import FilterRowsSvg from "@/components/UI/svg/FilterRowsSvg.vue";
import ToolTip from "@/components/UI/ToolTip.vue";
import HowItWorksButton from "@/pages/CreateConnection/HowItWorksButton.vue";


const filterTypes = ref([
    {
        dataProcessorType: 'FILTER',
        label: 'Фильтрация строк',
        icon: FilterRowsSvg,
        iconSize: 'size-10',
        toolTip: "Фильтрует данные по заданному значению"
    }
])


const emits = defineEmits(["select-filter", "skip-step"])


function selectType(value) {
    emits('select-filter', value)
}

function nextStep() {
    emits('skip-step')
}

</script>

<template>
    <div
        class="bg-white shadow-md rounded-3xl h-1/2 min-h-[380px] flex flex-col relative"

    >
        <div class="flex justify-between mt-5 mx-5">
            <div class="mx-4">
                <div class="text-sm lg:text-lg font-bold flex flex-col gap-4 justify-start">
                    <div class="mr-2 text-xl">Обработка данных</div>
                    <div class="mr-2 text-lg text-gray-600">Выберите тип фильтрации или трансформации данных</div>
                </div>
            </div>
            <div class="mr-10">
                <ToolTip text="Изучайте и исследуйте подробную информацию о том, как работает эта функция" position="bottom">
                    <HowItWorksButton />
                </ToolTip>
            </div>
        </div>
        <div class="mt-10 mx-5 flex flex-col">
            <div class="mb-2 mx-4">
                <div class="text-sm lg:text-lg font-bold">
                    Фильтрация данных
                </div>
            </div>
            <div class="flex mx-5">
                <ToolTip
                    :text="option.toolTip" position="bottom"
                    v-for="option in filterTypes"
                    :key="option.value"
                >

                    <div
                        class="border border-blue-200 px-3 py-2 rounded-md cursor-pointer bg-gray-50 text-gray-600 hover:bg-blue-50 duration-200 transition-all"
                        @click="selectType(option.value)"
                    >
                        <div class="w-full h-full flex items-center justify-center">
                            <component
                                :is="option.icon"
                                :class="option.iconSize"
                            />

                            <div class="font-bold text-xs ml-1 select-none">
                                {{ option.label }}
                            </div>
                        </div>
                    </div>
                </ToolTip>
            </div>
        </div>
        <div
            class="fixed left-1/2 -translate-x-1/2 sm:left-auto sm:right-4 md:right-6 lg:right-10 bottom-4 sm:bottom-5 px-5 py-3 rounded-full bg-blue-500 hover:bg-blue-600 duration-150 transition-all cursor-pointer select-none font-bold text-white z-30"
            v-on:click="nextStep"
        >
            Пропустить шаг
        </div>
    </div>
</template>

<style scoped>

</style>